import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";

import { VIEWS_LOG } from "graphql/query/analytics-gql";

import AnalyticsTable from "../analytics-table";
import { UserAvatar } from "components/user";
import Icons from "components/icons";



const prepareTableData = (data, pathBase) => {

    return data.map( (row) => {

        return {
            key: row.user.id,
            user : {
                value : <UserAvatar user={ row.user } size={ 62 } companyView="short"  />,
                title : <><Icons.Avatar type="simple" /> Visitor</>
            },
            views : {
                value : row.views,
                title : <><Icons.Eye type="product" className="product-views" /> Views</>
            },
            favorite : {
                value : row.product.my_favorite ? <Icons.Check className="check-icon" /> : "–",
                title : <><Icons.Favorite type="product"  className="product-favorites" /> Favorites</>
            },
            pdf : {
                value : row.pdf_views ? row.pdf_views : "–",
                title : <><Icons.File type="outline" className="document-views" /> Document views</>
            },
            video : {
                value : row.video_views ? row.video_views : "–",
                title : <><Icons.Video type="circle"  className="video-views" /> Video views</>
            },
            more: {
                value : <Link to={ `${pathBase}visitor/${ row.user.id }/`} className="analytics-more"><Icons.Arrow type="circle"  /></Link>,
                title : ""
            }
        };
    });

}

const AnalyticsProductSingleBlock = ({ standId, productId, currentPage = 1, pathBase}) => {

    const history = useHistory();

    const { data : { logViews } = {} , loading } = useQuery( VIEWS_LOG, {
        variables: {
            standId,
            page: currentPage,
            input: {
                model: 'product',
                id: productId
            },
            sortByOrder: {
                sortBy: 'VIEWS',
                sortOrder: 'DESC'
            }
        },
        fetchPolicy: "cache-and-network"
    });

    const tableData = logViews ? prepareTableData( logViews.data, pathBase ) : [];
    const { paginatorInfo } = logViews ?? {};

    return(
        <div className="analytics-block">
            { tableData &&
                <AnalyticsTable
                    tableData={ tableData }
                    loading={ loading }
                    emptyText="This product hasn't viewed any user yet"
                    pagination={{
                        pageSize: paginatorInfo?.perPage,
                        total: paginatorInfo?.total,
                        hideOnSinglePage: paginatorInfo?.total / paginatorInfo?.perPage > 1,
                        current: currentPage,
                        onChange: ( page ) => {
                            let path = page === 1 ? `${ pathBase }product/` : `${ pathBase }product/${ page }`

                            history.push( path );
                        }
                    }}
                />
            }
        </div>
    );

}

export default AnalyticsProductSingleBlock;